module.exports = require('./lib/type');



/*****************
 ** WEBPACK FOOTER
 ** ./~/deep-eql/~/type-detect/index.js
 ** module id = 142
 ** module chunks = 1
 **/